<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('addministration.department_feature.name_kh') }}
        </label>
        <input
          ref="department_name_kh"
          v-model="model.department_name_kh"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('department_name_kh') }"
          :placeholder="$t('addministration.department_feature.enter_name_kh')"
        />
        <div class="invalid-feedback" v-if="errors.has('department_name_kh')">
          {{ errors.first('department_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('addministration.department_feature.name_en') }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.department_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('department_name_en') }"
          :placeholder="$t('addministration.department_feature.enter_name_en')"
        />
        <div class="invalid-feedback" v-if="errors.has('department_name_en')">
          {{ errors.first('department_name_en') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.department_feature.description') }}
        </label>
        <textarea
          v-model="model.department_description"
          class="form-control"
          :class="{
            'is-invalid': errors.has('department_description')
          }"
          rows="3"
          :placeholder="
            $t('addministration.department_feature.enter_description')
          "
        ></textarea>
        <div
          class="invalid-feedback"
          v-if="errors.has('department_description')"
        >
          {{ errors.first('department_description') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('addministration.department_feature.cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('addministration.department_feature.update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('addministration.department_feature.save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'department-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        department_name_kh: '',
        department_name_en: '',
        department_description: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  computed: {},
  mounted() {
    this.$refs.department_name_kh.focus()
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('success_update')
      this.$router.push({ name: 'department' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'department/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.department_name_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'department/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'department' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.department_name_kh.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return

      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.department_name_kh = ''
      this.model.department_name_en = ''
      this.model.department_description = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
